import { Resume } from '@rio/types'
import { SettingsFieldChangeHandler } from 'builder/modules/resumeEditor'
import { TooltipV2 } from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { useLayoutBlockCustomisation } from '../../hooks/useLayoutBlockCustomisation'
import {
  SelectGroup,
  SelectControl,
  PlaceholderSpan,
  Label,
  FlexBox,
  ClickableOverlay,
} from './styles'

const STYLES = {
  SelectGroup,
  SelectControl,
  PlaceholderSpan,
  Label,
  FlexBox,
}

type Props = {
  resume: Resume
  onFieldChange?: SettingsFieldChangeHandler
  styles?: typeof STYLES
}

const TRANSLATION = 'builder.resume_editor.document_customization.sidebar.layout_tab'

export const EducationBlockOrderSelection = (props: Props) => {
  const { i18n } = useI18n()
  const { value, onSelect, isDisabled } = useLayoutBlockCustomisation(
    'educationOrder',
    props.resume,
    props.onFieldChange,
  )
  const Styles = props.styles || STYLES

  return (
    <TooltipV2
      value={i18n.t(`${TRANSLATION}.education_block_order_warning`)}
      width={250}
      multiline={true}
      position="bottom"
      isActive={isDisabled}
    >
      <Styles.SelectGroup>
        <Styles.SelectControl
          position="left"
          $height={120}
          label={
            <Styles.Label htmlFor="education-block-order-institution">
              {i18n.t(`${TRANSLATION}.education_block_order_label1`)}
            </Styles.Label>
          }
        >
          <input
            type="radio"
            id="education-block-order-institution"
            name="educationOrder"
            value="institution"
            checked={value === 'institution' && !isDisabled}
            onChange={onSelect}
            disabled={isDisabled}
          />
          <Styles.FlexBox
            as="label"
            alignItems="flex-start"
            htmlFor="education-block-order-institution"
          >
            <ClickableOverlay />
            <Styles.FlexBox
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              gap="0px"
            >
              <Styles.PlaceholderSpan size="Caption" alignText="left">
                {i18n.t(`${TRANSLATION}.education_block_order_label3`)}
              </Styles.PlaceholderSpan>
              <Styles.PlaceholderSpan color="Neutral50" alignText="right">
                {i18n.t(`${TRANSLATION}.education_block_order_label2`)}
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>
            <Styles.PlaceholderSpan size="Caption" alignText="right">
              2020
            </Styles.PlaceholderSpan>
          </Styles.FlexBox>

          <Styles.FlexBox
            as="label"
            alignItems="flex-start"
            htmlFor="education-block-order-institution"
          >
            <ClickableOverlay />
            <Styles.FlexBox
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              gap="0px"
            >
              <Styles.PlaceholderSpan size="Caption" alignText="left">
                {i18n.t(`${TRANSLATION}.education_block_order_label3`)}
              </Styles.PlaceholderSpan>
              <Styles.PlaceholderSpan color="Neutral50" alignText="right">
                {i18n.t(`${TRANSLATION}.education_block_order_label2`)}
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>
            <Styles.PlaceholderSpan size="Caption" alignText="right">
              2020
            </Styles.PlaceholderSpan>
          </Styles.FlexBox>
        </Styles.SelectControl>

        <Styles.SelectControl
          position="right"
          $height={120}
          label={
            <Styles.Label htmlFor="education-block-order-degree">
              {i18n.t(`${TRANSLATION}.education_block_order_label2`)}
            </Styles.Label>
          }
        >
          <input
            type="radio"
            id="education-block-order-degree"
            name="educationOrder"
            value="degree"
            checked={value === 'degree' && !isDisabled}
            onChange={onSelect}
            disabled={isDisabled}
          />
          <Styles.FlexBox as="label" alignItems="flex-start" htmlFor="education-block-order-degree">
            <ClickableOverlay />
            <Styles.FlexBox
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              gap="0px"
            >
              <Styles.PlaceholderSpan size="Caption" alignText="left">
                {i18n.t(`${TRANSLATION}.education_block_order_label2`)}
              </Styles.PlaceholderSpan>
              <Styles.PlaceholderSpan color="Neutral50" alignText="right">
                {i18n.t(`${TRANSLATION}.education_block_order_label3`)}
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>
            <Styles.PlaceholderSpan size="Caption" alignText="right">
              2020
            </Styles.PlaceholderSpan>
          </Styles.FlexBox>

          <Styles.FlexBox as="label" alignItems="flex-start" htmlFor="education-block-order-degree">
            <Styles.FlexBox
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              gap="0px"
            >
              <Styles.PlaceholderSpan size="Caption" alignText="left">
                {i18n.t(`${TRANSLATION}.education_block_order_label2`)}
              </Styles.PlaceholderSpan>
              <Styles.PlaceholderSpan color="Neutral50" alignText="right">
                {i18n.t(`${TRANSLATION}.education_block_order_label3`)}
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>
            <Styles.PlaceholderSpan size="Caption" alignText="right">
              2020
            </Styles.PlaceholderSpan>
          </Styles.FlexBox>
        </Styles.SelectControl>
      </Styles.SelectGroup>
    </TooltipV2>
  )
}
